import { fetchFromAPI } from 'utils/api';

export const updateAllDaysOnFeedTemperaturePoints = (resource) => {
  return fetchFromAPI('/admin/days_on_feed_temperature_points/update_all', {
    method: 'put',
    body: JSON.stringify({ resource }),
  })
    .then((response) => response) // Return full response including source
    .catch((response) => {
      throw response;
    });
};

export const updateTemperatureSetpointSource = (source) => {
  return fetchFromAPI('/admin/days_on_feed_temperature_points/update_source', {
    method: 'put',
    body: JSON.stringify({ resource: { source } }),
  })
    .then((response) => response)
    .catch((response) => {
      throw response;
    });
};
